<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          :disabled="disabled"
          fab
          small
          color="primary"
          v-on="on"
          :to="{ name: toName }"
          depressed
        >
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>
        <slot></slot>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'NewButton',
  props: {
    toName: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  }
}
</script>
